// @ts-nocheck

import React, { useCallback, useEffect } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import { ListWrapper } from '../../../../components/ListItem';
import MenuModal from '../../../../components/MenuModal';
import BetslipOptionsAddToBasketItemContainer from '../BetslipOptionsAddToBasketItem/BetslipOptionsAddToBasketItemContainer';
import BetslipOptionsHideItemContainer from '../BetslipOptionsHideitem/BetslipOptionsHideItemContainer';
import BetslipOptionsSaveItemContainer from '../BetslipOptionsSaveItem/BetslipOptionsSaveItemContainer';
import BetslipOptionsShareImageItemContainer from '../BetslipOptionsShareImageItem/BetslipOptionsShareImageItemContainer';
import BetslipOptionsShareLinkItemContainer from '../BetslipOptionsShareLinkItem/BetslipOptionsShareLinkItemContainer';
import BetslipOptionsShareSettingsItemContainer from '../BetslipOptionsShareSettingsItem/BetslipOptionsShareSettingsItemContainer';

const LIST_ITEM_BORDER_RADIUS = 15; // px

const StyledMenuModal = styled(MenuModal)``;

const StyledListWrapper = styled(ListWrapper)`
  border-radius: ${LIST_ITEM_BORDER_RADIUS}px;
  width: ${!Target.__MOBILE__ ? '380px' : 'auto'};

  ${({ $position, $isFixed }) =>
    $isFixed && !Target.__MOBILE__
      ? css`
          position: fixed;
          top: ${$position.y}px;
          left: ${$position.x}px;
          right: auto;
        `
      : null}
`;

type BetslipOptionsModalProps = {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
  showBasketMenuItem?: boolean;
  buttonRef?: HTMLElement;
  isFixed?: boolean;
};

const BetslipOptionsModal = ({
  className,
  isOpen,
  onClose,
  showBasketMenuItem,
  buttonRef,
  isFixed = false,
}: BetslipOptionsModalProps) => {
  const [position, setPosition] = React.useState({ x: 0, y: 0 });

  const onScroll = useCallback(() => {
    if (!buttonRef) {
      return null;
    }

    const { top, right } = buttonRef.getBoundingClientRect();

    setPosition({ x: right - 380, y: top + 40 });
  }, [buttonRef]);

  useEffect(() => {
    if (isFixed) {
      onScroll();
    }
  }, [isFixed, onScroll]);

  useEffect(() => {
    if (isFixed) {
      document?.addEventListener('scroll', () => onScroll());
    }
    return () => {
      document?.removeEventListener('scroll', () => onScroll());
    };
  }, [isFixed, onScroll]);

  return (
    <StyledMenuModal className={className} isOpen={isOpen} onClose={onClose}>
      <StyledListWrapper data-testid="menu-modal" $position={position} $isFixed={isFixed}>
        <BetslipOptionsShareImageItemContainer />
        {showBasketMenuItem ? <BetslipOptionsShareLinkItemContainer /> : null}
        <BetslipOptionsShareSettingsItemContainer />
        {showBasketMenuItem ? <BetslipOptionsAddToBasketItemContainer /> : null}
        <BetslipOptionsSaveItemContainer />
        <BetslipOptionsHideItemContainer />
      </StyledListWrapper>
    </StyledMenuModal>
  );
};

export default BetslipOptionsModal;
